import React from 'react';
import { useTranslation } from 'react-i18next';
import Form from '../../../../../antd/form/Form/Form.jsx';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField.jsx';
import FormTextArea from '../../../../../antd/form/FormTextArea/FormTextArea.jsx';
import FormSelect from '../../../../../antd/form/FormSelect/FormSelect.jsx';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import { required, empty } from '../../../../../antd/form/FormValidation.js';

const QuizzesForm = ({ initials, onSubmit, subjectOptions = [] }) => {
  const { t } = useTranslation();

  const subjectSelectOptions = subjectOptions.map((s) => ({
    value: s.id,
    label: s.name,
  }));

  return (
    <Form onFinish={onSubmit} initialValues={initials}>
      <FormSelect
        label={t('Predmet')}
        name={'study_subject_id'}
        options={subjectSelectOptions}
        rules={[required(t)]}
      />

      <FormTextField label={t('Názov')} name={'title'} rules={[empty(t)]} />

      <FormTextArea label={t('Popis')} name={'description'} />

      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'quizzes'}>
          {t('Uložiť')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

export default QuizzesForm;
